function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17.933 1.717L13 16.512a1.3 1.3 0 01-1.237.892h-.02a1.3 1.3 0 01-1.23-.93L8.653 10.27l4.853-4.854a.652.652 0 10-.922-.922L7.73 9.347 1.526 7.486a1.304 1.304 0 01-.038-2.487L16.283.067a1.304 1.304 0 011.65 1.65zM4.375 9.712a.652.652 0 00-.923 0L.191 12.973a.652.652 0 10.922.922l3.262-3.26a.653.653 0 000-.923zm3.913 3.913a.653.653 0 00-.922 0l-3.261 3.262a.652.652 0 10.922.922l3.261-3.261a.651.651 0 000-.923zm-3.287-.677a.652.652 0 00-.922.006L.84 16.238a.651.651 0 10.929.916l3.239-3.284A.652.652 0 005 12.948z",
  fill: "#B0B8CE"
});

function SvgOrderUnactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none"
  }, props), _ref);
}

export default SvgOrderUnactive;


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/order_unactive.svg
// module id = 1327
// module chunks = 10